(function() {
    'use strict';
    angular
        .module('emarket.main.profile')
        .controller('ProfileProductsController', ['$log', 'Post', 'Offer', '$mdToast', 'Auth', '$mdDialog', 'Profile', function($log,
            Post,
            Offer,
            $mdToast,
            Auth,
            $mdDialog,
            Profile) {
            var vm = this;
            var user = Auth.getUser();
            vm.refresh = {};

            var fetchPost = function() {
                return Profile.getPost(user._id).then(function(posts) {
                    vm.posts = posts;
                    if (posts.length === 0) {
                        vm.showEmptyState = true;
                    }
                });
            };
            fetchPost();
            function successMessage(message) {
                $log.info('calling');
                vm.selected = [];
                $mdToast.show($mdToast.simple().textContent(message));
            }
            function getPostsById(posts) {
                if (!Array.isArray(posts)) {
                    posts = [ posts ];
                }
                return vm.posts.filter(function(post) {
                    return posts.indexOf(post._id) !== -1;
                });
            }
            Profile.getStat().then(function(stat) {
                vm.plan = stat.characteristics;
                if (vm.plan.refresh === true) {
                    vm.canRefresh = true;
                }
                vm.hasStore = vm.plan.store;
            });
            vm.addSeasonPost = function(post) {
                if (!Array.isArray(post)) {
                    post = [ post ];
                }
                Profile.addSeasonPosts(post)
                    .then(function() {
                        var title = 'Productos agregados satisfactoriamente';
                        if (post.length === 1) {
                            title = 'Producto agregado satisfactoriamente';
                        }
                        successMessage(title);
                        var posts = getPostsById(post);
                        posts.forEach(function(post) {
                            post.prominent = 'season';
                        });
                    })
                    .catch(function(err) {
                        $log.error(err);
                    });
            };

            vm.addHighlightedPost = function(post) {
                if (!Array.isArray(post)) {
                    post = [ post ];
                }

                Profile.addHighlightedPosts(post)
                    .then(function() {
                        var title = 'Productos destacados satisfactoriamente';
                        if (post.length === 1) {
                            title = 'Producto destacado satisfactoriamente';
                        }
                        successMessage(title);
                        var posts = getPostsById(post);
                        posts.forEach(function(post) {
                            post.prominent = 'highlighted';
                        });
                    })
                    .catch(function(err) {
                        $log.error(err);
                    });
            };
            vm.removeSeasonPost = function(posts) {
                if (!Array.isArray(posts)) {
                    posts = [ posts ];
                }
                Profile.removeSeasonPosts(posts).then(function() {
                    var postList = getPostsById(posts);
                    postList.forEach(function(post) {
                        post.prominent = null;
                    });
                    successMessage('Eliminado correctamente');
                });
            };
            vm.removeHighlightedPost = function(posts) {
                if (!Array.isArray(posts)) {
                    posts = [ posts ];
                }
                Profile.removeHighlightedPosts(posts).then(function() {
                    var postList = getPostsById(posts);
                    postList.forEach(function(post) {
                        post.prominent = null;
                    });
                    successMessage('Eliminado correctamente');
                });
            };
            vm.refreshPost = function(post) {
                if (vm.canRepublish(post)) {
                    vm.refresh[post._id] = true;
                    Post.refresh(post._id)
                        .then(function(newPost) {
                            vm.refresh[post._id] = false;
                            post.endAt = newPost.endAt;
                            post.status = newPost.status;
                            $mdToast.show($mdToast.simple().textContent(post.title + ' Reiniciado Satisfactoriamente'));
                        })
                        .catch(function() {
                            vm.refresh[post._id] = false;
                        });
                }
            };
            vm.refreshSeveral = function() {
                Post.refreshSeveral(vm.selected)
                    .then(function(response) {
                        var message = 'Productos Reiniciados Satisfactoriamente';
                        if (response.incomplete && response.incomplete.length > 0) {
                            message = 'Algunos productos no pudieron ser reiniciados';
                            if (vm.selected.length === response.incomplete.length) {
                                message = 'Ningun producto pudo ser reiniciado, ya lo están';
                            }
                        }
                        $mdToast.show($mdToast.simple().textContent(message));
                        vm.selected = [];
                    })
                    .catch(function(err) {
                        $log.error('error ', err);
                    });
            };
            vm.showDialogOffer = function(post) {
                Offer.showManageDialog(post);
            };
            vm.offerCount = function(offers) {
                return offers.filter(function(offer) {
                    return offer.status === 'pending';
                }).length;
            };
            vm.delete = function(post, index) {
                if (post.isPremium) {
                    return $mdDialog.show($mdDialog.alert({
                        title: 'Imposible borrar un producto premium',
                        textContent:
                'Este producto esta catalogado como un producto premium y no puede ser borrado, si necesita asistencia comuniquese con nosotros al (829) 547-9783',
                        ok: 'Aceptar'
                    }));
                }
                var confirm = $mdDialog
                    .confirm()
                    .title('Eliminar ' + post.title)
                    .textContent('¿Esta seguro que desea eliminar este producto, esto no se puede deshacer?')
                    .ariaLabel('Eliminar')
                    .ok('Eliminar!')
                    .cancel('Cancelar');
                $mdDialog
                    .show(confirm)
                    .then(function() {
                        return Post.$buildRaw(post)
                            .$destroy()
                            .$asPromise();
                    })
                    .then(function() {
                        vm.posts.splice(index, 1);
                        if (vm.posts.length === 0) {
                            vm.showEmptyState = true;
                        }
                        successMessage('Eliminado correctamente');
                    })
                    .catch(function(err) {
                        $log.error(err);
                    });
            };
            vm.restartPosts = function() {
                if (vm.selected && vm.selected.length > 0) {
                    //TODO: make loading
                    Post.refresh(vm.selected)
                        .then(function() {
                            //TODO: stop loading and send user success message
                        })
                        .catch(function() {
                            //TODO: stop loading and send error message
                        });
                }
            };
            vm.deleteSeveral = function() {
                var confirm = $mdDialog
                    .confirm()
                    .title('Eliminar Varios Productos')
                    .textContent('¿Esta seguro que desea eliminar todos los producto seleccionados, esto no se puede deshacer?')
                    .ariaLabel('Eliminar')
                    .ok('ELIMINAR TODOS!')
                    .cancel('Cancelar');
                $mdDialog
                    .show(confirm)
                    .then(function() {
                        vm.deleting = true;
                        return Post.deleteSeveral(vm.selected);
                    })
                    .then(fetchPost)
                    .then(function() {
                        $mdToast.show($mdToast.simple().textContent('Borrado exitoso'));
                        vm.deleting = false;
                        vm.selected = [];
                    })
                    .catch(function(err) {
                        vm.deleting = false;
                        if (err) {
                            vm.selected = [];
                        }
                    });
            };
            vm.canRepublish = function canRepublish(post) {
                /* global moment */
                var diff = moment(moment(post.endAt).format('YYYY-MM-DD')).diff(moment().format('YYYY-MM-DD'),
                    'days');
                if (diff < 2) {
                    return true;
                }
                return false;
            };
            vm.selected = [];
        }]);
}());
